export const getOperatingSystem = () =>
    window.sessionStorage.getItem("operatingSystem") as
        | "android"
        | "ios"
        | undefined;
